<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed } from 'vue';
import { Status } from '@/components/common/editors/saveStatus/SaveStatuses';
import { SysarbColors } from '@/types';
import BadgeIcon from '@/components/common/BadgeIcon.vue';

const props = defineProps({
    status: {
        type: String as PropType<Status[keyof Status]>,
        default: Status.Info
    },
    message: {
        type: String,
        default: ''
    },
    transition: {
        type: Boolean,
        default: false
    },
    useBadgeIcon: {
        type: Boolean,
        default: false
    }
});

const statusIcon = computed(() => {
    if (props.status === Status.Success) {
        return {
            icon: 'check-circle-2',
            color: 'sy-icon-green'
        };
    }

    if (props.status === Status.Warning) {
        return {
            icon: 'alert-triangle',
            color: 'sy-icon-orange'
        };
    }

    if (props.status === Status.Error) {
        return {
            icon: 'x-circle',
            color: 'sy-icon-red'
        };
    }
    if (props.status === Status.Info) {
        return {
            icon: 'info',
            color: 'sy-icon-blue'
        };
    }
    return {
        icon: '',
        color: '',
    };
});

const badgeStatusIcon = computed(() => {
    if (props.status === Status.Error) {
        return {
            icon: 'x',
            color: SysarbColors.RED_500
        };
    }
    return {
        icon: 'x',
        color: SysarbColors.RED_500,
    };
});

const callOutTransition = computed(() => (props.transition ? 'fade-slide-down' : ''));
</script>
<template>
    <Transition
        :name="callOutTransition"
        mode="out-in"
        :appear="true"
    >
        <div v-bind="$attrs" :class="['sy-callout flex-container', status]">
            <slot name="status-icon">
                <div class="flex-container align-top">
                    <Icon
                        v-if="!useBadgeIcon"
                        :icon="statusIcon.icon"
                        :stroke="true"
                        :class="['margin-right-5', statusIcon.color]"
                    />
                    <BadgeIcon
                        v-else
                        :icon="badgeStatusIcon.icon"
                        :primary-color="badgeStatusIcon.color"
                        :filled="true"
                        size="small"
                        class="margin-right-5"
                    />
                </div>
            </slot>
            <slot>
                <p class="sy-type-ch-80 sy-pre-wrap">{{ message }}</p>
            </slot>
        </div>
    </Transition>
</template>
